module.exports = __webpack_public_path__ + "static/faq-95c235a5a079bf125bb8a2a1c642fa9a.png";